import { NextSeo } from 'next-seo';
import Link from 'next/link';
import React from 'react';
import useSWR from 'swr';

import Breadcrumbs from 'components/Breadcrumbs';
import Footer from 'components/Footer';
import MaxWidthContainer from 'components/MaxWidthContainer';
import Menubar from 'components/Menubar';
import MobileTabBar from 'components/MobileTabBar';
import { useAppLaunch } from 'contexts/AppLaunch';
import { swrFetcher } from 'utils/api';

const { useState } = React;

const LandingInfoCard = ({ article }) => {
  const { title, image, tags = [], slug } = article;

  return (
    <Link
      href={`/landing/${slug}`}
      className="group block w-[161px] overflow-hidden bg-white transition-all lg:w-[302px]"
    >
      <div className="h-[161px] w-[161px] overflow-hidden rounded-xl border border-gray-200 lg:h-[302px] lg:w-[302px]">
        <img
          src={image?.formats?.small?.url || image?.url || '/images/placeholders/article.png'}
          alt={title}
          className="h-full w-full object-cover transition-transform"
        />
      </div>

      <div className="">
        <h3 className="mt-4 line-clamp-2 text-lg font-medium text-[#0F1929] lg:mt-6 lg:text-xl">
          {title}
        </h3>
      </div>
    </Link>
  );
};

const BeautyInfoLanding = () => {
  const { notifications } = useAppLaunch();
  const [currentPage, setCurrentPage] = useState(1);

  const {
    data: articlesData,
    error,
    isLoading,
  } = useSWR(`/api/v4/landing-pages?page=${currentPage}&page_size=12`, swrFetcher);

  const articles = articlesData?.data || [];
  const totalCount = articlesData?.total_count || 0;
  const pageSize = articlesData?.page_size || 12;
  const totalPages = Math.ceil(totalCount / pageSize);

  const displayArticles = articles;

  const breadcrumbs = [
    { name: '首頁', href: '/' },
    { name: '美妝情報', href: null },
  ];

  return (
    <div>
      <NextSeo
        title="美妝情報 | SORRA"
        description="探索最新的美妝趨勢、產品評測與護膚技巧，讓你的美麗更加出眾"
        canonical="https://www.sorra.net/landing"
        openGraph={{
          url: 'https://www.sorra.net/landing',
          title: '美妝情報 | SORRA',
          description:
            '探索最新的美妝趨勢、產品評測與護膚技巧，讓你的美麗更加出眾',
          images: [
            {
              url: 'https://www.sorra.net/images/og-default.png',
              width: 800,
              height: 800,
              alt: '美妝情報',
            },
          ],
        }}
      />

      <Menubar
        props={{
          homeExtend: false,
          sourceUI: 'Landing',
        }}
      />

      <div
        className={
          'globals-centerContentsMargin relative' +
          (notifications && notifications.length > 0 ? ' withNoti' : '')
        }
      >
        <MaxWidthContainer className="px-4 lg:px-0">
          <div className="py-4 lg:py-8">
            <Breadcrumbs breadcrumbs={breadcrumbs} />
          </div>

          <div className="mb-8 lg:mb-12">
            <h1 className="text-2xl font-bold text-gray-900 lg:text-4xl">
              美妝情報
            </h1>
          </div>

          <div className="mb-12">
            {isLoading ? (
              <div className="grid grid-cols-2 gap-[18px] lg:grid-cols-4 lg:gap-6">
                {Array.from({ length: 8 }, (_, i) => (
                  <div key={i} className="animate-pulse">
                    <div className="h-[161px] w-[161px] rounded-xl bg-gray-200 lg:h-[302px] lg:w-[302px]"></div>
                    <div className="space-y-3 p-4">
                      <div className="h-4 w-1/4 rounded bg-gray-200"></div>
                      <div className="h-6 w-3/4 rounded bg-gray-200"></div>
                      <div className="space-y-2">
                        <div className="h-4 rounded bg-gray-200"></div>
                        <div className="h-4 w-5/6 rounded bg-gray-200"></div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            ) : (
              <div className="grid grid-cols-2 gap-[18px] lg:grid-cols-4 lg:gap-6">
                {displayArticles.map((article) => (
                  <LandingInfoCard key={article.id} article={article} />
                ))}
              </div>
            )}

            {/* 分頁 */}
            {totalPages > 1 && (
              <div className="mt-12 flex justify-center">
                <div className="flex space-x-2">
                  {Array.from({ length: totalPages }, (_, i) => i + 1).map(
                    (page) => (
                      <button
                        key={page}
                        onClick={() => setCurrentPage(page)}
                        className={`rounded-lg px-4 py-2 transition-colors ${
                          currentPage === page
                            ? 'bg-sorra-pink text-white'
                            : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                        }`}
                      >
                        {page}
                      </button>
                    )
                  )}
                </div>
              </div>
            )}
          </div>
        </MaxWidthContainer>

        <Footer />
        <MobileTabBar props={{ highlighted: 'campaign' }} />
      </div>
    </div>
  );
};

export default BeautyInfoLanding;
